import React, { Component } from 'react';

import { Mutation } from 'react-apollo';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';

import { withRouter } from 'react-router-dom';

import { Field, FormGroup, MultiFormGroup } from './Forms';

import {
  UPSERT_PERSON_MUTATION,
  DELETE_PERSON_MUTATION,
  PEOPLE_QUERY,
  peopleQueryVariables,
} from '../graphql.js';

export class PersonForm extends Component {
  state = { person: null };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      person: nextProps.person,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.deletePersonData && this.props.deletePersonData) {
      this.props.history.push('/');
    }
  }

  handleChange = name => event => {
    this.setState({
      person: {
        ...this.state.person,
        [name]: event.target.value,
      },
    });
  };

  render() {
    const {
      upsertPerson,
      upsertPersonLoading,
      upsertPersonError,
      upsertPersonData,
    } = this.props;

    const {
      deletePerson,
      deletePersonLoading,
      deletePersonError,
      deletePersonData,
    } = this.props;

    const { onSave } = this.props;

    const { person } = this.state;
    const isDirty = !isEqual(person, this.props.person);

    return (
      <form
        onSubmit={e => {
          e.preventDefault();
          upsertPerson(person);
          onSave();
        }}
      >
        <FormGroup
          name="Name"
          value={person.name}
          placeholder="ex: Michael Jackson"
          onChange={this.handleChange('name')}
          size="lg"
        />

        <FormGroup
          name="Info"
          type="textarea"
          value={person.info}
          placeholder="Super cool dude"
          onChange={this.handleChange('info')}
        />

        <FormGroup
          name="Facebook"
          value={person.fb}
          placeholder="ex: https://facebook.com/cgenco"
          type="url"
          onChange={this.handleChange('fb')}
        />

        <FormGroup
          name="Twitter"
          value={person.twitter}
          placeholder="ex: @cgenco"
          onChange={this.handleChange('twitter')}
        />

        <MultiFormGroup
          name="Locations"
          values={person.locations}
          onChange={locations =>
            this.setState({ person: { ...person, locations } })
          }
          newValue={() => ({ id: +new Date() })}
          renderField={({ value = {}, onChange, onDelete }) => {
            const { id, name, body } = value;
            return (
              <div className="form-row">
                <div className="col-8">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ex: Dallas, TX"
                    value={body}
                    onChange={e => onChange({ ...value, body: e.target.value })}
                  />
                </div>
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ex: Home"
                    value={name}
                    onChange={e => onChange({ ...value, name: e.target.value })}
                  />
                </div>
                {/* <div className="col"> */}
                <button
                  className="btn btn-outline-danger col"
                  onClick={e => {
                    e.preventDefault();
                    onDelete();
                  }}
                >
                  delete
                </button>
                {/* </div> */}
              </div>
            );
          }}
        />

        <div className="buttons" style={{ display: 'flex' }}>
          <a
            className="btn btn-danger"
            href="#"
            onClick={() => deletePerson(person)}
          >
            delete
          </a>

          <button
            className={
              'btn ' + (isDirty ? 'btn-primary' : 'btn-outline-primary')
            }
            style={{ flex: 1 }}
            type="submit"
          >
            save
          </button>
          <a className="btn btn-outline-secondary" href="#" onClick={onSave}>
            cancel
          </a>
        </div>

        <hr />
      </form>
    );
  }
}

export default withRouter(props => (
  <Mutation mutation={DELETE_PERSON_MUTATION}>
    {(
      deletePerson,
      {
        loading: deletePersonLoading,
        error: deletePersonError,
        data: deletePersonData,
      }
    ) => (
      <Mutation mutation={UPSERT_PERSON_MUTATION}>
        {(upsertPerson, { loading, error, data }) => (
          <PersonForm
            {...props}
            deletePerson={({ id }) => {
              deletePerson({
                variables: { id },
                update: (store, { data: { person } }) => {
                  // this feels so gross
                  const query = PEOPLE_QUERY;
                  const variables = peopleQueryVariables;
                  const data = store.readQuery({
                    query,
                    variables,
                  });

                  data.people.splice(
                    data.people.findIndex(person => person.id === id),
                    1
                  );

                  store.writeQuery({ query, variables, data });
                },
              });
            }}
            deletePersonLoading={deletePersonLoading}
            deletePersonError={deletePersonError}
            deletePersonData={deletePersonData}
            upsertPerson={person => {
              upsertPerson({
                variables: person,
              });
            }}
            upsertPersonLoading={loading}
            upsertPersonError={error}
            upsertPersonData={data}
          />
        )}
      </Mutation>
    )}
  </Mutation>
));



// WEBPACK FOOTER //
// ./src/components/PersonForm.js